<template>
  <div>
    <el-table :data="tableData">
      <el-table-column label="操作类型" prop="operationDesc"></el-table-column>
      <el-table-column
        label="谈判结果"
        prop="operationRemark"
      ></el-table-column>
      <el-table-column
        label="操作时间"
        prop="createTime"
        :formatter="formatter"
      ></el-table-column>
      <el-table-column label="IP地址/备注" prop="otherField"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import store from '@/store'
export default {
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    formatter(row) {
      return (
        row.createTime && dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss')
      )
    },
    init() {
      store
        .dispatch('listNegoOperationLog', {
          inquireId: this.row.inquireId,
          id: this.row.id
        })
        .then((res) => {
          this.tableData = res
        })
    }
  }
}
</script>

<style></style>
